import React from 'react';
import ContactSection from '../components/sections/Contact';

const Contact = () => {
  return (
    <>
      <div className="page-title">
        <div className="container">
          <div className="title-wrapper">
            <h1>Contact Us</h1>
            <p>Tell us about your project—we respond within one business day</p>
          </div>
        </div>
      </div>
      <ContactSection />
    </>
  );
};

export default Contact;
